import { FC } from 'react';
import { container } from 'system/registry';
import { LoadingProvider } from 'application/contexts/useLoading';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { agentUserContext, useAgentUser } from 'application/contexts/useAgentUser';
import { agentChatContext, useAgentChat } from 'application/contexts/useAgentChatRoom';
import { ScrollToTop } from 'ui/components/layouts/ScrollToTop';
import { LocationTracker } from 'application/hooks/useLocationTracker';
import { Outlet } from 'react-router-dom';

const AgentContextConfig: FC = () => {
    return (
        <LoadingProvider>
            <LocationTracker />
            <ScrollToTop />
            <AgentContexts />
        </LoadingProvider>
    );
};

const AgentContexts: FC = () => {
    const agentUserCtx = useAgentUser();
    const agentChatCtx = useAgentChat();
    return (
        <diContainerContext.Provider value={container}>
            <agentUserContext.Provider value={agentUserCtx}>
                <agentChatContext.Provider value={agentChatCtx}>
                    <Outlet />
                </agentChatContext.Provider>
            </agentUserContext.Provider>
        </diContainerContext.Provider>
    );
};

export default AgentContextConfig;
